<template>

<svg width="100" height="100" viewBox="0 0 100 100" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M20 35H80" stroke="black" stroke-width="4"/>
<path d="M20 50H80" stroke="black" stroke-width="4"/>
<path d="M20 65H80" stroke="black" stroke-width="4"/>
<path d="M50 13L58.6603 25H41.3398L50 13Z" fill="black"/>
<path d="M50 87L41.3397 75L58.6602 75L50 87Z" fill="black"/>
</svg>

</template>
